import {
    config,
    debug,
    formHelpers,
    helpers,
    i18n,
    inject,
    observable,
    observer,
    pr,
    React,
    RouteComponentProps,
    theme,
    ui,
} from "aaa";
import { toJS } from "mobx";
import { Loan } from "models/Loan";
import LoanCalculatorSlidersValues from "./LoanCalculatorSlidersValues";
import { RepresentativeExample } from "./RepresentativeExample";
import * as _ from "lodash";

type IProps = RouteComponentProps<{}> &
    i18n.InjectedIntlProps & {
        loan: Loan;
    };

const LEFT_COLUMN_WIDTH = "25%";

let __: any;

type CalculatorMethod = "values" | "sliders";

export const LoanParameters = (props: { amount: number; duration: number }) => {
    return (
        <div style={{ marginBottom: 10 }}>
            {ui.isDesktop ? (
                <div>
                    <pr.HFlex>
                        <div style={{ width: LEFT_COLUMN_WIDTH }}>
                            <pr.LightText>{ui.__("loan.amount")}</pr.LightText>
                        </div>
                        <div style={{ marginLeft: 60 }}>
                            <pr.LightText>
                                {helpers.numberToCurrencyString(props.amount)}
                            </pr.LightText>
                        </div>
                    </pr.HFlex>

                    <pr.HFlex style={{ marginTop: 10 }}>
                        <div style={{ width: LEFT_COLUMN_WIDTH }}>
                            <pr.LightText>
                                {ui.__("loan.duration")}
                            </pr.LightText>
                        </div>
                        <div style={{ marginLeft: 60 }}>
                            <pr.LightText>
                                {props.duration} {ui.__("years")}
                            </pr.LightText>
                        </div>
                    </pr.HFlex>
                </div>
            ) : (
                    <div>
                        <pr.LightTextSpan>{ui.__("loan.amount")}</pr.LightTextSpan>
                        <span style={{ float: "right" }}>
                            <pr.LightTextSpan>
                                {helpers.numberToCurrencyString(props.amount)}
                            </pr.LightTextSpan>
                        </span>
                        <br />
                        <pr.LightTextSpan>
                            {ui.__("loan.duration")}
                        </pr.LightTextSpan>
                        <span style={{ float: "right" }}>
                            <pr.LightTextSpan>
                                {props.duration} {ui.__("years")}
                            </pr.LightTextSpan>
                        </span>
                    </div>
                )}
        </div>
    );
};

export const LoanResult = (props: {
    totalAmount: number;
    interestRate: number;
    interestRateEffective: number;
    monthlyRate: number;
}) => {
    return (
        <div>
            {ui.isDesktop ? (
                <div>
                    <pr.HFlex>
                        <div style={{ width: LEFT_COLUMN_WIDTH }}>
                            {ui.__("loan.amountTotal")}
                        </div>
                        <div style={{ marginLeft: 60 }}>
                            <pr.Text>
                                {helpers.numberToCurrencyString(
                                    props.totalAmount
                                )}
                            </pr.Text>
                        </div>
                    </pr.HFlex>
                    <pr.HFlex>
                        <div
                            style={{ width: LEFT_COLUMN_WIDTH, marginTop: 10 }}
                        >
                            {ui.__("loan.interestRate")}
                        </div>
                        <div style={{ marginLeft: 60, marginTop: 10 }}>
                            <pr.Text>{`${props.interestRate.toLocaleString(
                                config.LOCALE
                            )}%`}</pr.Text>
                        </div>
                    </pr.HFlex>
                    <pr.HFlex>
                        <div
                            style={{ width: LEFT_COLUMN_WIDTH, marginTop: 10 }}
                        >
                            {ui.__("loan.interestRateEffective")}
                        </div>
                        <div style={{ marginLeft: 60, marginTop: 10 }}>
                            <pr.Text>{`${props.interestRateEffective.toLocaleString(
                                config.LOCALE
                            )}%`}</pr.Text>
                        </div>
                    </pr.HFlex>
                    <pr.HFlex style={{ marginTop: 10 }}>
                        <div style={{ width: LEFT_COLUMN_WIDTH }}>
                            <pr.TextH3>{ui.__("loan.monthlyRate")}</pr.TextH3>
                        </div>
                        <div style={{ marginLeft: 60 }}>
                            <pr.TextH3>
                                {helpers.numberToCurrencyString(
                                    props.monthlyRate
                                )}
                            </pr.TextH3>
                        </div>
                    </pr.HFlex>
                </div>
            ) : (
                    <div>
                        {ui.__("loan.amountTotal")}
                        <span style={{ float: "right" }}>
                            {helpers.numberToCurrencyString(props.totalAmount)}
                        </span>
                        <br />
                        {ui.__("loan.interestRate")}
                        <span
                            style={{ float: "right" }}
                        >{`${props.interestRate.toLocaleString(
                            config.LOCALE
                        )}%`}
                        </span>
                        <br />
                        {ui.__("loan.interestRateEffective")}
                        <span
                            style={{ float: "right" }}
                        >{`${props.interestRateEffective.toLocaleString(
                            config.LOCALE
                        )}%`}
                        </span>
                        <br />
                        <pr.TextH3>
                            {ui.__("loan.monthlyRate")}
                            <span style={{ float: "right" }}>
                                {helpers.numberToCurrencyString(props.monthlyRate)}
                            </span>
                        </pr.TextH3>
                    </div>
                )}
        </div>
    );
};

@i18n.injectIntl
@inject("loan")
@observer
export class LoanCalculator extends React.Component<IProps> {
    @observable
    repExText: string = "";

    constructor(props: IProps) {
        super(props);
        __ = i18n.bindStr(this.props.intl);
    }

    toggleMethod(method: CalculatorMethod) {
        this.props.loan.method = method;
    }

    onSubmit = () => {
        debug.log("### LoanCalculator", toJS(this.props.loan));

        this.props.history.push("/base");
    }

    doneImg = () => {
        return (
            <img
                src={require("../assets/done.svg")}
                alt="done_logo"
                width="24"
                height="24"
                style={{ marginRight: 8 }}
            />
        );
    }

    bulletPointHeader = () => {
        return (
            <div
                style={{
                    background: "#e5eef6",
                    marginBottom: theme.MARGIN_BIG
                }}
            >
                <div
                    style={{
                        display: "flex",
                        ...(ui.isMobile ? { flexDirection: "column" } : {}),
                    }}
                >
                    <div
                        style={{
                            paddingTop: theme.MARGIN_BIG,
                            paddingBottom: theme.MARGIN,
                            paddingLeft: theme.MARGIN_BIG,
                            paddingRight: theme.MARGIN_BIG,
                        }}
                    >
                        <h3
                            style={{
                                color: "#005aaa",
                                fontWeight: 400,
                            }}
                        >
                            {__("bulletPoint.header.title")}
                        </h3>
                        <div style={{ opacity: this.props.loan.isLoading ? 0 : 1 }}>
                            <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                                <li>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            minHeight: 22,
                                            fontSize: 14.5,
                                            marginBottom: 8,
                                            lineHeight: 1.43,
                                            letterSpacing: 0.1,
                                        }}
                                    >
                                        {this.doneImg()}
                                        <span>
                                            <b>
                                                {__(
                                                    "bulletPoint.header.reference.title"
                                                )}
                                            </b>
                                            {__(
                                                "bulletPoint.header.reference.description"
                                            )}
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            minHeight: 22,
                                            fontSize: 14.5,
                                            marginBottom: 8,
                                            lineHeight: 1.43,
                                            letterSpacing: 0.1,
                                        }}
                                    >
                                        {this.doneImg()}
                                        <span>
                                            <b>
                                                {__(
                                                    "bulletPoint.header.loanAmount.title"
                                                )}
                                            </b>
                                            {__(
                                                "bulletPoint.header.loanAmount.description", {
                                                    minAmount: helpers.numberToCurrencyString(this.props.loan.minAmount, false, false),
                                                    maxAmount: helpers.numberToCurrencyString(this.props.loan.maxAmount, false, false)
                                                }
                                            )}
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            minHeight: 22,
                                            fontSize: 14.5,
                                            marginBottom: 8,
                                            lineHeight: 1.43,
                                            letterSpacing: 0.1,
                                        }}
                                    >
                                        {this.doneImg()}
                                        <span>
                                            <b>
                                                {__(
                                                    "bulletPoint.header.refund.title"
                                                )}
                                            </b>
                                            {__(
                                                "bulletPoint.header.refund.description"
                                            )}
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            minHeight: 22,
                                            fontSize: 14.5,
                                            marginBottom: 8,
                                            lineHeight: 1.43,
                                            letterSpacing: 0.1,
                                        }}
                                    >
                                        {this.doneImg()}
                                        <span>
                                            <b>
                                                {__(
                                                    "bulletPoint.header.duration.title"
                                                )}
                                            </b>
                                            {__(
                                                "bulletPoint.header.duration.description", {
                                                    minDuration: this.props.loan.minDuration,
                                                    maxDuration: this.props.loan.maxDuration
                                                }
                                            )}
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            minHeight: 22,
                                            fontSize: 14.5,
                                            marginBottom: 8,
                                            lineHeight: 1.43,
                                            letterSpacing: 0.1,
                                        }}
                                    >
                                        {this.doneImg()}
                                        <span>
                                            <b>
                                                {__(
                                                    "bulletPoint.header.sollBinding.title"
                                                )}
                                            </b>
                                            {__(
                                                "bulletPoint.header.sollBinding.description"
                                            )}
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            minHeight: 22,
                                            fontSize: 14.5,
                                            marginBottom: 8,
                                            lineHeight: 1.43,
                                            letterSpacing: 0.1,
                                        }}
                                    >
                                        {this.doneImg()}
                                        <span>
                                            <b>
                                                {__(
                                                    "bulletPoint.header.securities.title"
                                                )}
                                            </b>
                                            {__(
                                                "bulletPoint.header.securities.description"
                                            )}
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            minHeight: 22,
                                            fontSize: 14.5,
                                            marginBottom: 8,
                                            lineHeight: 1.43,
                                            letterSpacing: 0.1,
                                        }}
                                    >
                                        {this.doneImg()}
                                        <span>
                                            <b>
                                                {__(
                                                    "bulletPoint.header.repayment.title"
                                                )}
                                            </b>
                                            {__(
                                                "bulletPoint.header.repayment.description"
                                            )}
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            minHeight: 22,
                                            fontSize: 14.5,
                                            // marginBottom: 8,
                                            lineHeight: 1.43,
                                            letterSpacing: 0.1,
                                        }}
                                    >
                                        {this.doneImg()}
                                        <span>
                                            <b>
                                                {__(
                                                    "bulletPoint.header.climatebonus.title"
                                                )}
                                            </b>
                                            {__(
                                                "bulletPoint.header.climatebonus.description"
                                            )}
                                        </span>
                                    </div>
                                    <div
                                        style={{
                                            // display: "flex",
                                            // alignItems: "center",
                                            minHeight: 22,
                                            fontSize: 14.5,
                                            marginBottom: 8,
                                            lineHeight: 1.43,
                                            letterSpacing: 0.1,
                                        }}
                                    >
                                        <ul style={{ marginLeft: 5, listStyleType: "disc" }}>
                                            <i18n.FormattedHTMLMessage id="bulletPoint.header.climatebonus.listitems" />
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {/* <img
                        src={require("../assets/prozentsatz_logo.png")}
                        alt="badge image"
                        height="200"
                        style={{
                            // paddingRight: 5,
                            ...(ui.isMobile
                                ? {
                                    alignSelf: "center",
                                    paddingBottom: theme.MARGIN,
                                }
                                : {
                                    alignSelf: "center",
                                    // paddingBottom: 160
                                }),
                        }}
                    /> */}
                    <div
                        style={{
                            opacity: this.props.loan.isLoading ? 0 : 1,
                            position: "relative",
                            height: 200,
                            minWidth: 200,
                            color: "white",
                            ...(ui.isMobile
                                ? {
                                    alignSelf: "center",
                                    paddingBottom: theme.MARGIN,
                                }
                                : {
                                    alignSelf: "center",
                                    // paddingBottom: 160
                                }),
                        }}
                    >
                        <img
                            src={require("../assets/prozentsatz_logo_empty.png")}
                            alt="badge image"
                            height="200"
                            style={{ pointerEvents: "none" }}
                        />
                        <span
                            style={{
                                position: "absolute",
                                top: "63px",
                                right: "60px",
                                fontSize: "48px",
                                letterSpacing: this.props.loan.logoEffectiveInterestRate >= 10 ? "3px" : "5px",
                                fontWeight: "bold",
                                fontFamily: "\"Fjalla One\""
                            }}
                        >
                            <i18n.FormattedNumber
                                value={this.props.loan.logoEffectiveInterestRate}
                                minimumIntegerDigits={1}
                                minimumFractionDigits={2}
                                maximumFractionDigits={2}
                            />

                        </span>
                        <span
                            style={{
                                position: "absolute",
                                top: "67px",
                                left: "140px",
                                fontSize: "26px",
                                fontFamily: "\"Fjalla One\""
                            }}
                        >
                            %
                        </span>
                        <span
                            style={{
                                position: "absolute",
                                top: "99px",
                                left: "142px",
                                fontSize: "14px",
                                fontFamily: "Roboto",
                                letterSpacing: "1px"
                            }}
                        >
                            {__("pa")}
                        </span>
                        <span
                            style={{
                                position: "absolute",
                                top: "124px",
                                left: "0px",
                                right: "0px",
                                fontSize: "14px",
                                fontFamily: "Roboto",
                                textAlign: "center",
                                letterSpacing: "0.5px"
                            }}
                        >
                            {_.upperFirst(__("representativeExample.interestEffective"))}
                        </span>
                    </div>

                </div>
                <div style={{ fontSize: 12, paddingLeft: theme.MARGIN_BIG, paddingRight: theme.MARGIN_BIG, paddingBottom: theme.MARGIN }}>
                    {/* tslint:disable-next-line:max-line-length */}
                    <p><i18n.FormattedHTMLMessage id="bulletPoint.bottomparagraph" /></p>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div style={{ paddingBottom: theme.MARGIN_BIG }}>
                {this.bulletPointHeader()}

                {this.props.loan.isLoading ? <div style={{ height: 300, opacity: 0 }}>loading...</div> : (

                    <div>
                        <div
                            style={{
                                paddingLeft: theme.MARGIN_BIG,
                                paddingRight: theme.MARGIN_BIG,
                            }}
                        >
                            <pr.Title style={{ marginBottom: 20 }}>
                                {__("loanCalculator")}
                            </pr.Title>

                            <LoanCalculatorSlidersValues loan={this.props.loan} />

                            <LoanResult
                                totalAmount={this.props.loan.totalAmount}
                                interestRate={this.props.loan.interestRate}
                                interestRateEffective={
                                    this.props.loan.interestRateEffective
                                }
                                monthlyRate={this.props.loan.monthlyRate}
                            />
                        </div>


                        {formHelpers.renderActionButton(
                            __("loan.request"),
                            !this.props.loan.interestSet,
                            this.onSubmit
                        )}

                        <div
                            style={{
                                marginTop: 40,
                                paddingLeft: theme.MARGIN_BIG,
                                paddingRight: theme.MARGIN_BIG,
                            }}
                        >
                            {ui.__("product.info.text")}
                        </div>
                        <div
                            style={{
                                marginTop: -20,
                                marginLeft: 0,
                                paddingLeft: 80,
                                marginBottom: 20,
                            }}
                        >
                            <i18n.FormattedHTMLMessage
                                id="product.info.documents"
                                values={{
                                    maxAmount: helpers.numberToCurrencyString(
                                        this.props.loan.maxAmount,
                                        false
                                    ),
                                }}
                            />
                        </div>

                        <RepresentativeExample
                            style={{
                                marginTop: -20,
                                paddingLeft: theme.MARGIN_BIG,
                                paddingRight: theme.MARGIN_BIG,
                            }}
                            interestSet={this.props.loan.interestSet}
                        />
                    </div>
                )}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LoanCalculator.tsx